import { ApplicationMenuItem } from '@mediacoach/ui'

export interface Permission {
  regex: RegExp
  deepLength: number
  isDefaultRoute: boolean
}

export interface UserProfile {
  id: string
  name: string
  surname: string
  fullName: string
  language: string
  email: string
  humanizedRoles: string
  permissions: Permission[]
  cachedDateTime?: string
  userId?: string
  favouriteCompetitionId: string
  favouriteTeamId: string
  favourites: {
    competitionId: string
    teamId: string
  }
  profiles: ApplicationMenuItem[]
  customerTeamTranslationKey?: string
  photoPath?: string
  tenantConfiguration?: TenantConfiguration
  onBoardingStep: number

  // new analytics fields
  favouriteTeamName?: string
  customerId?: string
  customerName?: string // already received
  color?: string
  avatarPath?: string
  avatar?: string
  clubTeamLogoUrl?: string
}

export interface TenantSupportedLanguage {
  id: string
  translationKey: string
}

export interface TenantConfiguration {
  tenantId: string
  supportedLanguages?: TenantSupportedLanguage[]
}

export enum AuthError {
  UserDisallowed = 'user_disallowed_for_client',
  InvalidGrant = 'invalid_grant',
  InvalidRequest = 'invalid_request'
}
